import React from "react";
import PropTypes from "prop-types";
import {
    Card,
    Divider,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Box
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MKTypography from "components/MKTypography";
import {
    Phone,
    Email,
    Place,
    AccessTime,
} from "@mui/icons-material";
import { BRAND, COMPANY, LAT, LNG } from "../constants";

export default function CompanyInfoCard() {
    const telHref = `tel:${COMPANY.telefone.replace(/\s/g, "")}`;
    const mailHref = `mailto:${COMPANY.email}`;
    const waHref = `https://wa.me/${COMPANY.whatsapp}`;

    const mapsExternalLink = `https://www.google.com/maps?q=${LAT},${LNG}&z=17&output=embed`;
    const mapSrc = `https://maps.app.goo.gl/WTbpHANUGCCyGRAx6`;

    const Item = ({ icon, primary, secondary }) => (
        <ListItem sx={{ px: 0, py: 0.5 }}>
            <ListItemIcon sx={{ minWidth: 40, color: BRAND.main }}>{icon}</ListItemIcon>
            <ListItemText
                primary={
                    <MKTypography variant="button" fontWeight="small" color="text">
                        {primary}
                    </MKTypography>
                }
                secondary={
                    <MKTypography variant="body2" color="text" sx={{ mt: 0.5 }}>
                        {secondary}
                    </MKTypography>
                }
            />
        </ListItem>
    );

    Item.propTypes = {
        icon: PropTypes.node.isRequired,
        primary: PropTypes.node.isRequired,
        secondary: PropTypes.node,
    };

    return (
        <Card sx={{ p: 3, height: "100%", display: "flex", flexDirection: "column" }}>
            <MKTypography variant="body2" color="text" sx={{ mb: 1 }}>
                Entre em contato conosco através dos canais abaixo:
            </MKTypography>

            <Box sx={{ flexGrow: 1 }}>
                <List sx={{ py: 0, display: "flex", flexDirection: "column" }}>
                    <Item
                        icon={<Place fontSize="small" />}
                        primary="Endereço"
                        secondary={COMPANY.endereco}
                    />
                    <Item
                        icon={<Phone fontSize="small" />}
                        primary="Telefone (Comercial)"
                        secondary={
                            <Link href={telHref} underline="hover" color="inherit">
                                {COMPANY.telefone}
                            </Link>
                        }
                    />
                    <Item
                        icon={<WhatsAppIcon fontSize="small" />}
                        primary="WhatsApp"
                        secondary={
                            <Link href={waHref} underline="hover" color="inherit" target="_blank" rel="noopener">
                                +55 11 9 9885-9120
                            </Link>
                        }
                    />
                    <Item
                        icon={<Email fontSize="small" />}
                        primary="E-mail"
                        secondary={
                            <Link href={mailHref} underline="hover" color="inherit">
                                {COMPANY.email}
                            </Link>
                        }
                    />
                    <Item
                        icon={<AccessTime fontSize="small" />}
                        primary="Horário de atendimento"
                        secondary={COMPANY.horario}
                    />
                </List>
            </Box>

            <Divider
                sx={{
                    mt: { xs: 4, md: 6 },
                    height: 2,
                    border: "none",
                    background:
                        "linear-gradient(90deg, rgba(3,109,61,0) 0%, rgba(3,109,61,.35) 25%, rgba(3,109,61,.5) 50%, rgba(3,109,61,.35) 75%, rgba(3,109,61,0) 100%)",
                }}
            />


            {/* MAPA */}
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    // aspect-ratio ajuda a manter responsivo; fallback com height fixa abaixo
                    aspectRatio: "16 / 9",
                    borderRadius: 2,
                    overflow: "hidden",
                    boxShadow: 1,
                    // fallback para navegadores sem aspect-ratio
                    "&::before": {
                        content: '""',
                        display: "block",
                        paddingTop: "56.25%",
                    },
                }}
            >
                <Box
                    component="iframe"
                    title="Localização da empresa no mapa"
                    src={mapsExternalLink}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    allowFullScreen
                    sx={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        border: 0,
                    }}
                />
            </Box>

            <Box >
                <Link href={mapSrc} target="_blank" rel="noopener noreferrer" underline="hover" color="inherit" sx={{ fontSize: 12 }}>
                    Ver no Google Maps
                </Link>
            </Box>
        </Card>
    );
}
